import { BCMSRecord, Link, ModalOpen, useBCMSModal, useGlobalController, useRoute } from "@bcm-dev/bcms-vite";
import InfoNotificationView from "compid/shared/views/Notifications/InfoNotificationView";
import { Bill } from "model";
import React from "react";
import "./styles.css";

/**
 * @function BillDueNotificationView
 * @param {String} amount - amount shown in the notification
 * @param {String} dueDate - due date shown in the notification
 * @return {React.Component}
 * @exported true
 * @description Shows the details of the bill due 
 * @example
 * <BillDueNotificationView amount="$10.00" dueDate="Jan 01" />
 */

export default function BillDueNotificationView(props) {
  const controller = useGlobalController();
  const navigate = useRoute();
  const { close } = useBCMSModal();
  const bill = props.bill ?? Bill.firstInstanceOf();
  const amount = bill.amount.format();
  const dueDate = bill.formatDate;
  const viewBillPath = `/viewBillWorkflow/${ bill.id }`;
  const billDetailsPath = `/payBills`;

  const markAsPaid = () => {
    bill.status = "Paid";

    BCMSRecord.batch([
      Bill.update(bill)
    ], controller);

    close("AlreadyPaidBillModal");
    navigate(billDetailsPath);
  };

  const alreadyPaidBillModalData = { markAsPaid: markAsPaid };
  
  return(
      <InfoNotificationView 
      className="bill-due-notification-view" 
      icon="EbillsIcon" 
      text={
        <div className="flex-container flex-horizontal align-center space-between text-container">
          <p className="blue-text">{amount} due on {dueDate}</p>
          <div className="flex-container flex-horizontal align-right justify-right links-container">
            <Link className="blue-text set-width divider-after">
              <ModalOpen id="AlreadyPaidBillModal" data={ alreadyPaidBillModalData }>Mark bill as paid</ModalOpen>
            </Link>
            <Link className="blue-text set-width" to={ viewBillPath }>View bill</Link>
          </div>
        </div>} 
        textClass="" />
  );
}